// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-36611234] .el-tab-pane{height:100%}[data-v-36611234] .el-tabs__content{height:calc(100% - 60px);overflow-y:auto}.edit-site[data-v-36611234],[data-v-36611234] .el-tabs{height:100%}.edit-site[data-v-36611234]{color:#080707}.edit-site[data-v-36611234]  .el-tabs__nav{margin-left:20px}.edit-site[data-v-36611234]  .el-tabs__item{padding:0 40px}.edit-site[data-v-36611234]  .el-tabs__item.is-active{color:#080707;font-weight:700}[data-v-36611234] .menu{height:100%}", ""]);
// Exports
module.exports = exports;
